import { mapKanemaUser, mapKatswiriUser, mapMingoliUser } from "../mappers/userMapper";
import { User } from "../types/user";
import { getAllKanemaUsers, getAllKatswiriUsers, getMingoliUsers } from "./services";

export const getUnifiedUsers = async (): Promise<User[]> => {
    const katswiriRaw = await getAllKatswiriUsers();
    const kanemaRaw = await getAllKanemaUsers();
    const mingoliRaw = await getMingoliUsers();
  
    return [
      ...katswiriRaw.map(mapKatswiriUser),
      ...kanemaRaw.map(mapKanemaUser),
      ...mingoliRaw.map(mapMingoliUser),
    ];
  };